import { useState, useEffect } from "react";
import I18n from "common/i18n";
import { useScale } from "common/utils";
import { Layout, Overlay } from "features/creator/tutorial/top/stages/Layout";
import { Title } from "../Title";

const Step = (props: { back: () => void; next: () => void; close: () => void }) => {
  const { scale } = useScale();
  const { next, close } = props;
  const [panelRect, setPanelRect] = useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
  });

  useEffect(() => {
    setTimeout(() => {
      const panel = document.getElementById("creator-display-copy-btn");
      const rect = panel.getBoundingClientRect();
      setPanelRect({
        x: rect.x - 10 * scale,
        y: rect.y - 30 * scale,
        width: rect.width + 20 * scale,
        height: rect.width + 20 * scale,
      });
    }, 300);
  }, [scale]);

  return (
    <>
      <Overlay area={panelRect}>
        <></>
      </Overlay>

      <Layout transparent next={next} close={close}>
        <Title activeStep={4} />

        <div className="flex-col-el items-start justify-center w-[312px]">
          <p className="text-body text-textcolor-black text-[22px] whitespace-pre">
            {I18n.locale === "ja" ? "きどうちゅうの アプリを" : "起動中のアプリを"}
          </p>
          <div className="flex-row-el flex-center gap-2">
            <div className="flex-row-el flex-center px-3 bg-orange-100 rounded-xl">
              <p className="text-body text-[20px] leading-8 text-white">
                {I18n.t("MSG_CREATOR_APP_MY_APPS")}
              </p>
            </div>

            <p className="text-body text-textcolor-black text-[22px] whitespace-pre">に</p>
          </div>
          <p className="text-body text-textcolor-black text-[22px] whitespace-pre">
            {"コピーすることも\nできます。"}
          </p>
        </div>
      </Layout>
    </>
  );
};

export default Step;
